module.exports = __webpack_public_path__ + "img/sec1_box5.7f57aa05.jpg";